import { Injectable } from '@angular/core';

const QUICKQUOTEUTILITYINFO = {
    customerType: '',
    customerTypeSize: '',
    loadProfile: '',
    annualUsage: '',
}

@Injectable({
    providedIn: 'root'
})
export class QuickQuoteUtilityService {
    constructor() { }

    getCustomerType(): string {
        return QUICKQUOTEUTILITYINFO.customerType;
    }

    setCustomerType(value: string): void {
        QUICKQUOTEUTILITYINFO.customerType = value;
    }

    getCustomerTypeSize(): string {
        return QUICKQUOTEUTILITYINFO.customerTypeSize;
    }

    setCustomerTypeSize(value: string): void {
        QUICKQUOTEUTILITYINFO.customerTypeSize = value;
    }
    
    getLoadProfile(): string {
        return QUICKQUOTEUTILITYINFO.loadProfile;
    }

    setLoadProfile(value: string): void {
        QUICKQUOTEUTILITYINFO.loadProfile = value;
    }
    getAnnualUsage(): string {
        return QUICKQUOTEUTILITYINFO.annualUsage;
    }

    setAnnualUsage(value: string): void {
        QUICKQUOTEUTILITYINFO.annualUsage = value;
    }
}
